module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/notosanskr/notokr-medium.woff
// module id = JV2C
// module chunks = 0